export default {
  cabinetsForDropdown: [],
  cabinetsAppointments: [],
  designations: [],
  designation: null,
  schedulePatientList: [],
  schedulePatient: null,
  calendarColors: [
    'primary', 'danger', 'warning', 'success', 'info'
  ],
  calendarOptions: [],
  selectedCalendars: [],
  scheduleCalendarView: null,
  schedulePatientStatuses: [
    {
      key: 'wait',
      label: 'Ожидаем подтверждения',
      color: 'yellow',
    },
    {
      key: 'accept',
      label: 'Подтвердил прием',
      color: 'info',
    },
    {
      key: 'arrive',
      label: 'Пациент пришел',
      color: 'success',
    },
    {
      key: 'change',
      label: 'Перенос',
      color: 'orange',
    },
    {
      key: 'abort',
      label: 'Отменен',
      color: 'danger',
    },
    {
      key: 'finished',
      label: 'Завершен',
      color: 'finished',
    },
    {
      key: 'not-arrive',
      label: 'Не пришел',
      color: 'warning',
    },
    {
      key: 'online-registration',
      label: 'Online-запись',
      color: 'purple',
    },
    {
      key: 'break',
      label: 'Перерыв',
      color: 'primary',
    }
  ],
  eventColors: {
    primary: '#7367f0',
    success: '#79f8b1',
    info: '#a3fcfc',
    warning: '#fb8197',
    danger: '#f38a8b',
    orange: '#ffd099',
    yellow: '#eefa70',
    purple: '#e993e7',
    finished: '#00cb58'
  },
  scheduleToEdit: null,
  doctorShiftsForAppointmentCalendar: [],
  doctorWeekendDates: [],
  selectedServiceTime: null,
  patientAwaitStatus: [],
  calendarDateSelected: '',
  cabinetsForUser: [],
  activeRange: null,
  listDayExtendedCalendarDateState: null,
  componentToRender: null,
  selectedDoctorId: null,
  selectedDoctors: [],
  selectedSidebarDoctorId: null,
  selectedSidebarDoctorIds: [],
  activeTab: null,
  newPatientAppointmentInfo: null,
  newPatientAppointmentInfoWatcher: null,
  doctors: [],
  selectedDaysInEmployeeScheduleCalendar: [],
  copiedEmployeeScheduleStatusInCalendar: null,
  // Scheduler patient notification timeouts
  schedulerPatientNotificationTimeouts: [
    {value: 1, label: '1 мин.'},
    {value: 5, label: '5 мин.'},
    {value: 10, label: '10 мин.'},
    {value: 15, label: '15 мин.'},
    {value: 30, label: '30 мин.'},
    {value: 60, label: '1 ч.'}
  ],
}
